import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dateComAnoterVersion'
})
export class DateComAnoterVersionPipe implements PipeTransform {

  transform(arr: any, code: any, code2: any): any {
    if ( code == '' || code == null || code == undefined || code == 'undefined' || code == 'All' || arr == [] || arr == undefined || arr == null) {
      return arr;
    } else{
      return arr.filter((arr: any) =>{
        return arr.dateorder >= code && arr.datereceipt <= code2
      })
    }
  }

}
